import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../static/icons/chevron-down.svg'


const _hoisted_1 = { class: "footer-links" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "footer-links__list" }

import { inject, reactive } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterLinks',
  setup(__props) {

const footerLinks = inject('$footerLinksReactive');
const { websiteText } = useWebsiteTexts();

const openSections = reactive(new Set());

function addSection(id) {
  openSections.has(id) ? openSections.delete(id) : openSections.add(id);
}

function isSectionOpen(id) {
  return openSections.has(id);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footerLinks), (section) => {
      return (_openBlock(), _createElementBlock("div", {
        key: section.id,
        class: _normalizeClass(["footer-links__section", { 'footer-links__section--open': isSectionOpen(section.id) }])
      }, [
        _createElementVNode("h2", {
          onClick: ($event: any) => (addSection(section.id)),
          class: "footer-links__title"
        }, [
          _createTextVNode(_toDisplayString(section.label) + " ", 1),
          _createElementVNode("img", {
            class: "footer-links__title-arrow",
            src: _imports_0,
            alt: 
            isSectionOpen(section.id)
              ? _unref(websiteText)('global__close_section').value
              : _unref(websiteText)('global__open_section').value
          
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: "footer-links__list-item"
            }, [
              _createVNode(_component_router_link, {
                to: item.url,
                class: "footer-links__link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ], 2))
    }), 128))
  ]))
}
}

})